// src/app/interceptors/language.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private translate: TranslateService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.has('Accept-Language')) {
      return next.handle(req);
    }

    const lang =
      this.translate.currentLang ||
      this.translate.defaultLang ||
      this.translate.getBrowserLang() ||
      'en';

    const modifiedReq = req.clone({
      setHeaders: { 'Accept-Language': lang }
    });

    return next.handle(modifiedReq);
  }
}
